import React from 'react'
import {Button, Form, Modal} from "react-bootstrap";
import {Save, X} from "react-feather";
import {checkValidation, handleUserSave} from "../../API/benutzermanagement";
import UserModal from "./UserModal";


const NewUserModal = (elem) => {
    return (
        <div>
            <Modal
                size="md" aria-labelledby="contained-modal-title-vcenter"
                centered
                animation={false}
                show={elem.props.editNewUserModalShow}
                onHide={() => elem.changeState({editNewUserModalShow: false})}
            >

                <Modal.Header closeButton>

                    <Modal.Title>Handwai | Neuer Benutzer
                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <UserModal props={elem.props} onSelectedGenderChange={elem.onSelectedGenderChange}
                                   updateNameForm={elem.updateNameForm}
                                   onSelectedRoleChange={elem.onSelectedRoleChange} usermodal='NewUserModal'
                                   onSelectedBusinessRoleChange={elem.onSelectedBusinessRoleChange}
                                   onSelectedCompanyChange={elem.onSelectedCompanyChange} changeState={elem.changeState}/>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={!checkValidation(elem.props)} size="lg" block variant="outline-success"
                            onClick={() => {
                                elem.changeState({editNewUserModalShow: false})
                                handleUserSave(elem.props, elem.changeState, 1)}
                            }><Save/>&nbsp;&nbsp;Speichern</Button>

                    <Button size="lg" variant="outline-dark" style={{width: "100%"}}
                            onClick={() => elem.changeState({editNewUserModalShow: false})}><X/>
                        &nbsp;&nbsp;Abbrechen
                    </Button>
                </Modal.Footer>

            </Modal>
        </div>
    )
};

export default NewUserModal
